import { useMemo } from 'react';

import { Group, GroupMembershipType } from '@/types/groups';

// Groups that can be manually assigned through a selector: excludes groups
// synced in from an HRIS integration and dynamic (rule-derived) groups, since
// membership in both is managed automatically rather than by hand.
export const useManageableGroups = (allGroups: Group[]) =>
  useMemo(
    () =>
      allGroups.filter(
        group =>
          !group.hrisGroupIntegration &&
          group.membershipType !== GroupMembershipType.Dynamic
      ),
    [allGroups]
  );

// The subset of an employee's current groups that can't be manually added or
// removed here: dynamic (rule-derived) groups and groups synced in from an
// HRIS integration. Meant to be shown as read-only and passed as
// `lockedGroups` to `EmployeeGroupSelector`.
export const useReadOnlyGroups = (employeeGroups: Group[]) =>
  useMemo(
    () =>
      employeeGroups.filter(
        group =>
          group.membershipType === GroupMembershipType.Dynamic ||
          !!group.hrisGroupIntegration
      ),
    [employeeGroups]
  );
